import React, { useState, useEffect } from "react";
import Plan_bg from "../images/Plan_Bg.webp";
import axios from "axios";

export const Pmwani = ({ slugData }) => {
  const slug = slugData || "";

  const decodeHTML = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  const createMarkup = (content) => {
    return { __html: decodeHTML(content) };
  };

  const [plan, setPlan] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const res = await axios.get(
          window.weburl + `api/plans.php?catID=17&pid=${slug}`,
        );

        if (res.data?.data?.length > 0) {
          setPlan(res.data.data[0]);
        }
      } catch (err) {
        console.error(err);
      }
    };

    loadData();
  }, [slug]);

  if (!plan) return null;

  const features = plan.features ? plan.features.split("|_") : [];

  return (
    <div className="plansitem single-card">
      <div className="ptag">
        <h5 dangerouslySetInnerHTML={createMarkup(plan.pname)} />
      </div>

      <div className="image_plans_div">
        <div className="image_plan">
          <img src={Plan_bg} alt="Plan" />
        </div>
        <p dangerouslySetInnerHTML={createMarkup(plan.ptitle)} />
      </div>

      <div className="price">
        <div className="sprice">
          <h6>{plan.price}</h6>
        </div>

        {/* ✅ FIXED: HTML render correctly */}
        {features.length > 0 && (
          <ul>
            {features.map((item, i) =>
              item ? (
                <li
                  key={i}
                  dangerouslySetInnerHTML={{ __html: decodeHTML(item) }}
                />
              ) : null,
            )}
          </ul>
        )}
      </div>
    </div>
  );
};
